import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class DeliveryTermReferenceService extends BaseReferenceService {
  constructor() {
    super('DeliveryTermReference');
  }
}
